export default __webpack_public_path__ + "static/media/traing.3ccdca6c.jpg";